import React, { useState } from 'react';
import { Container, Card,Button } from 'react-bootstrap';
import { CardBody } from 'reactstrap';
import Draggable from 'react-draggable';
import AddNotes from './Notes';
import { Btn, H5 } from '../../../../AbstractElements';
import { Input, ModalBody, ModalHeader, ModalFooter, Modal, Form } from 'reactstrap';
import CloseModal from '../../../../Constant/CloseModal';


const Notes = () => {
  const [note, setNote] = useState([]);
  // const [notes, setNotes] = useState(false);
  const [notes, setNotes] = useState([]);

  const addNote = () => {
    const now = new Date().toLocaleDateString(); // Get current date
    setNotes([
      ...notes,
      { id: Date.now(), date: now, title: '', content: '', name: '' }
    ]);
  };

  const updateNote = (id, field, value) => {
    setNotes(
      notes.map(note =>
        note.id === id ? { ...note, [field]: value } : note
      )
    );
  };


 
  const [selectedNote, setSelectedNote] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = (note = null) => {
    setSelectedNote(note);
    setModalOpen(!modalOpen);
  };
 
  return (
    <Container className="my-4">
      
        {/* <Card style={{ width: '18rem' }} > */}
        <Card style={{ width: '18rem', cursor: 'pointer' }}  onClick={() => toggleModal(note)}>
              <CardBody>
                <Card.Title>{note?.name || 'Untitled'}</Card.Title>
                <Card.Text>{note?.content || 'No content'}</Card.Text>
              </CardBody>
            </Card>
            {selectedNote && (
        <Draggable>
        <Modal className='notes'  isOpen={modalOpen}  size="xs" centered>
          <div className="d-flex justify-content-between bg-info text-secondary">
            <ModalHeader>Notes</ModalHeader>
            <div className='p-3' style={{ cursor: "pointer" }} onClick={toggleModal}>
              <CloseModal />
            </div>
          </div>
          <ModalBody className='bg-info text-secondary'>
            <Form>
              <div className='d-flex justify-content-between'>
                <H5 className='font-secondary'>{'Patient Name'}</H5>
                <Input
                  type='text'
                  className='border-0 shadow-none bg-transparent input-style text-center'
                  placeholder='Enter Title'
                  value={note.name}
                  onChange={(e) => updateNote('name', e.target.value)}
                />
                <H5>{note?.date || '08/02/2024' }</H5>
              </div>
              <div>
                <Input
                className='border-0 shadow-none bg-transparent border-bottom input-style'
                  type='textarea'
                  placeholder='Notes'
                  value={note.content}
                  onChange={(e) => updateNote(selectedNote.id,'content', e.target.value)}
                />
              </div>
            </Form>
          </ModalBody>
          <ModalFooter className='bg-info'>
            <Btn attrBtn={{ color: 'secondary', onClick: toggleModal }}>Close</Btn>
            <Btn attrBtn={{ color: 'primary', onClick: toggleModal }}>Save Changes</Btn>
          </ModalFooter>
        </Modal>
      </Draggable>
      )}
    </Container>
  );
}


export default Notes;
